import axios from 'axios';

// API URL - build-time default; override at runtime via window.__SUPERADMIN_API_BASE_URL__
// (e.g. set to http://localhost:30801/api when using NodePort without port-forward)
const API_BASE_URL =
  (typeof window !== 'undefined' && window.__SUPERADMIN_API_BASE_URL__) ||
  process.env.REACT_APP_API_URL ||
  'http://localhost:8001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('superadmin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth / IP access errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = String(error.config?.url || '');
    const isAuthLoginRequest =
      requestUrl.includes('/auth/login') ||
      requestUrl.includes('/auth/verify-mfa') ||
      requestUrl.includes('/auth/verify-otp') ||
      requestUrl.includes('/auth/mfa/') ||
      requestUrl.includes('/auth/resend-otp') ||
      requestUrl.includes('/auth/client/login');

    const code = error.response?.data?.code;
    if (error.response?.status === 403 && code === 'IP_NOT_ALLOWED') {
      localStorage.removeItem('superadmin_token');
      localStorage.removeItem('superadmin_user');
      try {
        sessionStorage.setItem('ip_access_denied', JSON.stringify({
          ip: error.response?.data?.ip || '',
          message: error.response?.data?.message || '',
          detail: error.response?.data?.detail || '',
          reason: error.response?.data?.reason || ''
        }));
      } catch { /* ignore */ }
      if (!window.location.pathname.startsWith('/access-denied')) {
        window.location.href = '/access-denied';
      }
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !isAuthLoginRequest) {
      localStorage.removeItem('superadmin_token');
      localStorage.removeItem('superadmin_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
export { API_BASE_URL };
